export default __webpack_public_path__ + "static/media/neetrepeaterhindibanner.de488195.png";